<template>
  <b-container fluid>
    <b-row>
      <b-col xs="12" sm="12" md="6" lg="6">
        <!-- patient card start -->
<!--        <b-col>-->
<!--          <iq-card class-name="iq-user-profile-block1">-->
<!--            <template v-slot:body>-->
<!--              <div class="user-details-block">-->
<!--                <div class="user-profile text-center">-->
<!--                  <img v-if="patient.gender === 0" src="../../assets/images/user/11.png" alt="profile-img"-->
<!--                       class="avatar-130 img-fluid">-->
<!--                  <img v-else src="../../assets/images/user/19.png" alt="profile-img" class="avatar-130 img-fluid">-->
<!--                </div>-->
<!--                <div class="text-center mt-3">-->
<!--                  &lt;!&ndash;              <h3><b>编号：{{patient.pdid}}</b></h3>&ndash;&gt;-->
<!--                  <h6 class="text-primary">原发疾病</h6>-->
<!--                  <h4><b>{{ patient.originDisease }}</b></h4>-->
<!--                </div>-->
<!--                <ul class="doctoe-sedual d-flex align-items-center justify-content-between p-0 mt-4 mb-0">-->
<!--                  <li class="text-center">-->
<!--                    <h6 class="text-primary">编号</h6>-->
<!--                    <h4> - </h4>-->
<!--                  </li>-->
<!--                  <li class="text-center">-->
<!--                    <h6 class="text-primary">性别</h6>-->
<!--                    <h4 v-if="patient.gender === 0">女</h4>-->
<!--                    <h4 v-else>男</h4>-->
<!--                  </li>-->
<!--                  <li class="text-center">-->
<!--                    <h6 class="text-primary">出生年份</h6>-->
<!--                    <h4 v-if="patient.birthDate != null">{{ patient.birthDate.substring(0, 4) }}</h4>-->
<!--                    <h4 v-else>暂无数据</h4>-->
<!--                  </li>-->
<!--                </ul>-->
<!--                <br/>-->
<!--                <div style="padding-bottom:20px;text-align:center">-->
<!--                  <a data-icon="T" class="icon" v-if="display === false"-->
<!--                     @click="display = !display; $store.commit('setShowLine', true)">-->
<!--                    <span>更多</span>-->
<!--                  </a>-->
<!--                  <a data-icon="W" class="icon" v-else-->
<!--                     @click="display = !display ; $store.commit('setShowLine', false)">-->
<!--                    <span>收起</span>-->
<!--                  </a>-->
<!--                </div>-->
<!--                <b-collapse id="collapse-0" class="mb-2" v-model="display">-->
<!--                  <div class="d-flex align-items-center justify-content-between">-->
<!--                    <b-col>-->
<!--                      <div class="data-block">-->
<!--                        <p class="mb-0">身高</p>-->
<!--                        <h5 v-if="patient.height == undefined">暂无数据</h5>-->
<!--                        <div v-else>-->
<!--                          <h5>{{ change(patient.height) }}&nbsp;<span>cm</span></h5>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="data-block mt-3">-->
<!--                        <p class="mb-0">体重</p>-->
<!--                        <h5 v-if="patient.weight == undefined">暂无数据</h5>-->
<!--                        <div v-else>-->
<!--                          <h5>{{ change(patient.weight) }}&nbsp;<span>kg</span></h5>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="data-block mt-3">-->
<!--                        <p class="mb-0">入院年龄</p>-->
<!--                        <h5 v-if="patient.age == undefined">暂无数据</h5>-->
<!--                        <div v-else>-->
<!--                          <h5>{{ patient.age }}&nbsp;<span>岁</span></h5>-->
<!--                        </div>-->
<!--                      </div>-->
<!--                      <div class="data-block mt-3" v-if="patient.death == 1">-->
<!--                        <p class="mb-0">去世年份-月份</p>-->
<!--                        <h5>{{ patient.deathDate.substring(0, 7) }}</h5>-->
<!--                      </div>-->
<!--                      <div class="data-block mt-3" v-else>-->
<!--                        <p class="mb-0">现状</p>-->
<!--                        <h5>正在治疗</h5>-->
<!--                      </div>-->
<!--                      <div class="data-block mt-3"-->
<!--                           v-show="patient.amputation === 1 || patient.ch === 1 || patient.ci === 1 || patient.mi === 1 || patient.chd === 1 || patient.lung_infect === 1 || patient.heart_failure === 1 || patient.diabetes === 1">-->
<!--                        <p class="mb-0">基础病症</p>-->
<!--                        <h5>{{-->
<!--                            (patient.diabetes === 1 ? '糖尿病 ' : '') +-->
<!--                            (patient.heart_failure === 1 ? '心脏衰竭 ' : '') +-->
<!--                            (patient.lung_infect === 1 ? '肺部感染 ' : '') +-->
<!--                            (patient.chd === 1 ? '冠心病 ' : '') +-->
<!--                            (patient.mi === 1 ? '心梗 ' : '') +-->
<!--                            (patient.ci === 1 ? '脑梗 ' : '') +-->
<!--                            (patient.ch === 1 ? '脑出血 ' : '') +-->
<!--                            (patient.amputation === 1 ? '截肢 ' : '')-->
<!--                          }}</h5>-->
<!--                      </div>-->
<!--                      <div class="data-block mt-3" v-show="patient.death == 1">-->
<!--                        <p class="mb-0">死因</p>-->
<!--                        <h5>{{ patient.deathReasonText }}</h5>-->
<!--                      </div>-->
<!--                    </b-col>-->
<!--                  </div>-->
<!--                </b-collapse>-->
<!--              </div>-->
<!--            </template>-->
<!--          </iq-card>-->
<!--        </b-col>-->
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">指标</h4>
          </template>
          <template v-slot:headerAction>
            <div style="padding-right: 20px">
              <a @click="$store.commit('setSelectedGraph', [])">
                <span>清空已选</span>
              </a>
            </div>
          </template>
          <template v-slot:body>
            <div class="iq-header-title" v-show="patient_data_selector.special.length">
              <h4 class="card-title text-primary">特别指标</h4>
            </div>
            <div class="iq-card-body ml-0 mr-0 mb-0" v-show="patient_data_selector.special.length">
              <PatientDataSelector :item="patient_data_selector.special">
              </PatientDataSelector>
            </div>
            <div class="iq-header-title" v-show="patient_data_selector.important.length">
              <h4 class="card-title text-primary">重要指标</h4>
            </div>
            <div class="iq-card-body ml-0 mr-0 mb-0" v-show="patient_data_selector.important.length">
              <PatientDataSelector :item="patient_data_selector.important">
              </PatientDataSelector>
            </div>
            <div class="iq-header-title" v-show="patient_data_selector.other.length">
              <div style="padding-bottom:20px;text-align:center">
                <a data-icon="T" class="icon" v-if="display1 === false" @click="display1 = !display1">
                  <span>更多</span>
                </a>
                <a data-icon="W" class="icon" v-else @click="display1 = !display1">
                  <span>收起</span>
                </a>
              </div>
              <!--              <b-button v-b-toggle.collapse-1 variant="primary">Toggle Collapse</b-button>-->
            </div>
            <div class="iq-card-body pl-0 pr-0 pb-0" v-show="patient_data_selector.other.length">
              <b-collapse id="collapse-1" class="mb-2" v-model="display1">
                <h4 class="card-title text-primary">其他指标</h4>
                <PatientDataSelector :item="patient_data_selector.other"></PatientDataSelector>
              </b-collapse>
            </div>
          </template>
        </iq-card>
      </b-col>
      <b-col id="chart">
        <PatientDataChart/>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import IqCard from '../../components/xray/cards/iq-card'
import { xray } from '@/config/pluginInit'
import { medicalCharChinese } from '@/util/info'
import SpecialPatientDataChart from '../Charts/SpecialPatientDataChart'
import SpecialPatientDataSelector from '../Charts/SpecialPatientDataSelector'
import ColorHelper from '../../util/ColorHelper'
import { specialData, medicalStandard, specialMedical } from '@/util/specialInfo1'

const body = document.getElementsByTagName('body')
export default {
  name: 'Dashboard4',
  components: {
    IqCard,
    PatientDataChart: SpecialPatientDataChart,
    PatientDataSelector: SpecialPatientDataSelector
  },
  inject: ['reload'],
  data() {
    return {
      bg_color: [
        'bg-warning',
        'bg-primary',
        'bg-info',
        'bg-danger',
        'bg-success',
        'bg-secondary'
      ],
      hoverIndex: -1, // 菜单hover索引
      activeLinkId: 0, // 当前激活的菜单id
      message: '默认值',
      genderRatio: 0,
      display: false,
      display1: false,
      dialog: false,
      top2: undefined,
      urlAnalyzeApi: undefined,
      settings: undefined,
      getAnalyzeDataTimer: undefined,
      getAdviceTimer: undefined,
      similarPatientsAttn: [],
      medicalCharChinese: medicalCharChinese,
      patient_data_selector: {
        special: [],
        important: [],
        other: [],
        item: [],
        info: {}
      }
    }
  },
  created() {
    this.$store.commit('setLab', specialData)
    this.$store.commit('setSpecialModifiedLab', this.lab)
    if (this.$store.state.ch) {
      this.$store.commit('setCh', new ColorHelper())
    }
    this.getRank()
  },
  mounted() {
    xray.index()
    body[0].classList.add('sidebar-main-menu')
  },
  destroyed() {
    body[0].classList.remove('sidebar-main-menu')
  },
  computed: {
    selectedGraph() {
      return this.$store.state.selectedGraph
    },
    modifiedLab() {
      return this.$store.state.specialModifiedLab
    },
    lab() {
      return this.$store.state.lab
    },
    ch() {
      return this.$store.state.ch
    },
    patient() {
      return this.$store.state.specialPatient
    }
  },
  watch: {
    '$route'(to, from) { // 监听路由是否变化
      if (to.name === 'dashboard.home-4') { // 跳转到哪个页面
        this.reload()
      }
    }
  },
  methods: {
    enter: function () {
      this.color = 'blue'
    },
    leave: function () {
      this.color = 'red'
    },
    change(a) {
      const b = parseFloat(a)
      return b.toFixed(1)
    },
    getRank() {
      this.patient_data_selector.item = Object.keys(this.lab[0])
      this.patient_data_selector.item.splice(this.patient_data_selector.item.indexOf('date'), 1)
      this.patient_data_selector.item.forEach(e => {
        let flag = false
        if (medicalStandard[e] !== undefined) {
          this.lab.forEach(l => {
            if (l[e] > medicalStandard[e][1] || l[e] < medicalStandard[e][0]) {
              flag = true
            }
          })
        }
        if (flag) {
          this.patient_data_selector.important.push(e)
        } else {
          this.patient_data_selector.other.push(e)
        }
      })
      if (specialMedical !== undefined) {
        this.patient_data_selector.special = specialMedical
      }
      this.patient_data_selector.important = this.patient_data_selector.important.filter(item => {
        return !this.patient_data_selector.special.includes(item)
      })
      this.patient_data_selector.other = this.patient_data_selector.other.filter(item => {
        return !this.patient_data_selector.special.includes(item)
      })
      this.$store.commit('setSelectedDate', [])
    }
  }
}
</script>

<style scoped>
.link-item-hover {
  background-color: #f5f7fa;
}

.link-item-active {
  color: #fff;
  background-color: #b3cae4;
}

.guide {
  width: 16px;
  padding-left: 2px;
  padding-bottom: 5px;
  cursor: pointer;
}

.chart {
  position: fixed;
  right: 0px;
}
</style>
